import { ooFetchWithResponse } from './ooFetchWithResponse';

let healthApi = {
    createExercise: async ({ name, doneAt, description }) => {
        let url = 'health/v1/exercises';
        const body = JSON.stringify({ name, doneAt, description });
        let response = await ooFetchWithResponse(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body,
        });
        return response;
    },
    updateExercise: async ({ id, name, doneAt, description }) => {
        let url = `health/v1/exercises/${encodeURIComponent(id)}`;
        const body = JSON.stringify({ name, doneAt, description });
        let response = await ooFetchWithResponse(url, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body,
        });
        return response;
    },
    createMedication: async ({ name, takenAt }) => {
        let url = 'health/v1/medications';
        const body = JSON.stringify({ name, takenAt });
        let response = await ooFetchWithResponse(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body,
        });
        return response;
    },
    updateIssue: async ({ id, issue, description, severity, startedAt, resolvedAt }) => {
        let url = `health/v1/issues/${encodeURIComponent(id)}`;
        const body = JSON.stringify({ issue, description, severity, startedAt, resolvedAt });
        let response = await ooFetchWithResponse(url, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body,
        });
        return response;
    },
    createIssue: async ({ issue, description, severity, startedAt, resolvedAt }) => {
        let url = 'health/v1/issues';
        const body = JSON.stringify({ issue, description, severity, startedAt, resolvedAt });
        let response = await ooFetchWithResponse(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body,
        });
        return response;
    },
    getBloodPressure: async ({ startDate, endDate } = {}) => {
        let url = 'health/v1/bloodPressure';
        const params = new URLSearchParams();
        if (startDate) params.set('startDate', startDate);
        if (endDate) params.set('endDate', endDate);
        if ([...params.keys()].length > 0) {
            url += `?${params.toString()}`;
        }
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    createBloodPressure: async ({ systolic, diastolic, createdAt }) => {
        let url = 'health/v1/bloodPressure';
        // Backend expects 'doneAt' but we use 'createdAt' in the UI
        const body = JSON.stringify({ systolic, diastolic, doneAt: createdAt });
        let response = await ooFetchWithResponse(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body,
        });
        return response;
    },
    getSleep: async ({ startDate, endDate } = {}) => {
        let url = 'health/v1/sleep';
        const params = new URLSearchParams();
        if (startDate) params.set('startDate', startDate);
        if (endDate) params.set('endDate', endDate);
        if ([...params.keys()].length > 0) {
            url += `?${params.toString()}`;
        }
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    createSleep: async ({ nightOf, quality, magnesiumTaken, notes }) => {
        let url = 'health/v1/sleep';
        const body = JSON.stringify({ nightOf, quality, magnesiumTaken, notes });
        let response = await ooFetchWithResponse(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body,
        });
        return response;
    },
    getExercises: async ({ startDate, endDate } = {}) => {
        let url = 'health/v1/exercises';
        const params = new URLSearchParams();
        if (startDate) params.set('startDate', startDate);
        if (endDate) params.set('endDate', endDate);
        if ([...params.keys()].length > 0) {
            url += `?${params.toString()}`;
        }
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    getIssues: async ({ startDate, endDate } = {}) => {
        let url = 'health/v1/issues';
        const params = new URLSearchParams();
        if (startDate) params.set('startDate', startDate);
        if (endDate) params.set('endDate', endDate);
        if ([...params.keys()].length > 0) {
            url += `?${params.toString()}`;
        }
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    getIssueOnDay: async ({ issues } = {}) => {
        let url = 'health/v1/issueByDay';
        const params = new URLSearchParams();
        if (issues) params.set('issues', issues);
        if ([...params.keys()].length > 0) {
            url += `?${params.toString()}`;
        }
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
    getMedications: async ({ startDate, endDate } = {}) => {
        let url = 'health/v1/medications';
        const params = new URLSearchParams();
        if (startDate) params.set('startDate', startDate);
        if (endDate) params.set('endDate', endDate);
        if ([...params.keys()].length > 0) {
            url += `?${params.toString()}`;
        }
        let response = await ooFetchWithResponse(url, {
            method: 'GET',
        });
        return response;
    },
}

export { healthApi };